import { css } from 'styled-components';
import { isResponsiveTypeSpec, } from '../types';
import { WEB_BREAKPOINT_QUERIES } from '../tokens/breakpoints';
export const typeSpec = (typeSpec, responsive = false) => {
    const specBlock = (spec) => {
        const { fontFamily, lineHeight, fontSize, letterSpacing } = spec;
        return css `
      margin: 0;
      padding: 0;
      font-family: ${fontFamily};
      font-size: ${fontSize}px;
      letter-spacing: ${letterSpacing}px;
      line-height: ${lineHeight}px;
    `;
    };
    if (!isResponsiveTypeSpec(typeSpec)) {
        return specBlock(typeSpec);
    }
    if (!responsive) {
        return specBlock(typeSpec.SM);
    }
    return css `
    /* stylelint-disable */
    @media ${WEB_BREAKPOINT_QUERIES['xs-to-md']} {
      ${specBlock(typeSpec.SM)}
    }

    @media ${WEB_BREAKPOINT_QUERIES['md-up']} {
      ${specBlock(typeSpec.LG)}
    }
  `;
};
